<h1 mat-dialog-title>
  {{ title }}
</h1>

<mat-divider></mat-divider>

<div mat-dialog-content>
  <p>{{ message }}</p>
</div>

<mat-divider></mat-divider>

<div mat-dialog-actions align="end">
  <button mat-button mat-raised-button color="accent" (click)="onDismiss()">No</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Yes</button>
</div>
